import React from 'react';

const HalfHeight = ({ className }) => {
    return (
        <svg
            className={className}
            width={200}
            height={117}
            viewBox="0 0 200 117"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            //{...props}
        >
            <mask
            id="mask0_2017_362"
            style={{
                maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={200}
            height={117}
            >
            <path
                d="M193.822 0H6.17788C2.7689 0 0.00537109 2.76353 0.00537109 6.17251V110.796C0.00537109 114.205 2.7689 116.969 6.17788 116.969H193.822C197.231 116.969 199.995 114.205 199.995 110.796V6.17251C199.995 2.76353 197.231 0 193.822 0Z"
                fill="white"
            />
            </mask>
            <g mask="url(#mask0_2017_362)">
            <path
                d="M193.822 0H6.17788C2.7689 0 0.00537109 2.76353 0.00537109 6.17251V110.796C0.00537109 114.205 2.7689 116.969 6.17788 116.969H193.822C197.231 116.969 199.995 114.205 199.995 110.796V6.17251C199.995 2.76353 197.231 0 193.822 0Z"
                fill="#404040"
            />
            <path
                d="M69.446 21.6035H130.4"
                stroke="white"
                strokeWidth={4.62938}
                strokeLinecap="round"
            />
            <path
                d="M51.5459 32.0967H92.5931"
                stroke="#818181"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M130.863 32.0967H148.146"
                stroke="#818181"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M101.852 32.0967H121.604"
                stroke="#818181"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M93.2103 42.8989H54.6322C52.9277 42.8989 51.5459 44.2807 51.5459 45.9852V54.0094C51.5459 55.7139 52.9277 57.0957 54.6322 57.0957H93.2103C94.9148 57.0957 96.2966 55.7139 96.2966 54.0094V45.9852C96.2966 44.2807 94.9148 42.8989 93.2103 42.8989Z"
                fill="#E66819"
            />
            <path
                d="M64.1995 49.8428H83.3342"
                stroke="white"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M142.899 42.8989H104.321C102.616 42.8989 101.234 44.2807 101.234 45.9852V54.0094C101.234 55.7139 102.616 57.0957 104.321 57.0957H142.899C144.603 57.0957 145.985 55.7139 145.985 54.0094V45.9852C145.985 44.2807 144.603 42.8989 142.899 42.8989Z"
                fill="#767676"
            />
            <path
                d="M113.888 49.8428H133.023"
                stroke="white"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <g opacity={0.59}>
                <path
                d="M183.869 52.1317L173.463 64.5536C170.036 68.6444 172.945 74.8752 178.282 74.8752H228.607C233.436 74.8752 236.461 69.6561 234.061 65.4656L222.197 44.7543C220.064 41.0298 214.907 40.4922 212.051 43.6964L203.988 52.7413C201.765 55.2362 197.977 55.5544 195.368 53.4653L192.616 51.2617C189.949 49.1257 186.064 49.5121 183.869 52.1317Z"
                fill="#818181"
                />
                <path
                opacity={0.18}
                d="M7.56668 59.2559C34.0715 59.2559 55.5579 37.7695 55.5579 11.2647C55.5579 -15.2402 34.0715 -36.7266 7.56668 -36.7266C-18.9382 -36.7266 -40.4246 -15.2402 -40.4246 11.2647C-40.4246 37.7695 -18.9382 59.2559 7.56668 59.2559Z"
                fill="#E66819"
                />
                <path
                d="M7.47625 29.9862C17.7101 29.9862 26.0062 21.69 26.0062 11.4562C26.0062 1.22241 17.7101 -7.07373 7.47625 -7.07373C-2.75757 -7.07373 -11.0537 1.22241 -11.0537 11.4562C-11.0537 21.69 -2.75757 29.9862 7.47625 29.9862Z"
                fill="#E66819"
                />
            </g>
            <path
                d="M208.019 71.9097H-4.31543V144.745H208.019V71.9097Z"
                fill="#F4F0EC"
            />
            <path
                d="M61.4219 97.5254H94.4448"
                stroke="#C4C4C4"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M101.852 97.5254H118.209"
                stroke="#C4C4C4"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M125.307 97.5254H141.664"
                stroke="#C4C4C4"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M75.9272 90.1187H123.764"
                stroke="#818181"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            </g>
        </svg>
    )
}

export default HalfHeight;